import React from "react";
import classNames from "classnames";

import { Size } from "../../../types/types";

interface Props {
  slug: string;
  landscape?: boolean;
  enabled?: boolean;
  onClick?: (slug: string) => void;
  size?: Size;
}

export const Card: React.FC<Props> = ({
  slug = undefined,
  enabled = false,
  landscape = false,
  size = Size.M,
  onClick,
}): React.ReactElement => {
  let fileName: string;
  if (landscape) {
    fileName = `landscape_${slug}.jpg`;
  } else {
    fileName = `${slug}.jpg`;
  }

  const handleClick = () => {
    if (enabled && onClick && slug) {
      onClick(slug);
    }
  };
  
  return (
    <button
      type="button"
      onClick={handleClick}
      className={classNames(
        "transition-all duration-150",
        { "hover:scale-110 hover:-translate-y-2": enabled && onClick },
        { "cursor-pointer": enabled && onClick },
        { "cursor-default": !onClick }
      )}
    >
      {/* https://stackoverflow.com/questions/45334874/load-images-based-on-dynamic-path-in-reactjs */}
      <img
        src={process.env.PUBLIC_URL + "/cards/" + fileName}
        alt={slug}
        className={classNames(
          "rounded-lg h-auto shadow-md",
          { "w-48": size === Size.XL },
          { "w-36": size === Size.L },
          { "w-24": size === Size.M },
          { "w-16": size === Size.S },
          { "w-12": size === Size.XS },
          { "w-6 rounded-sm": size === Size.XXS },
          { "ring-2 ring-gray-400": !enabled },
          { "ring-4 ring-emerald-400 shadow-emerald-400/50 shadow-lg": enabled }
        )}
      />
    </button>
  );
};
